export const STALE_TAB_OVERLAY_FADE_MS = 220;
export const STALE_TAB_OVERLAY_STORAGE_KEY = "cc-reload-overlay";
export const STALE_TAB_OVERLAY_ATTRIBUTE = "data-cc-reload-overlay";

/** One-shot handoff; keep the cover visible before the new document hydrates. */
export const STALE_TAB_OVERLAY_BOOTSTRAP = `(()=>{try{const k=${JSON.stringify(STALE_TAB_OVERLAY_STORAGE_KEY)},a=${JSON.stringify(STALE_TAB_OVERLAY_ATTRIBUTE)},t=Number(sessionStorage.getItem(k));sessionStorage.removeItem(k);if(t>0&&Date.now()-t>=0&&Date.now()-t<30000){document.documentElement.setAttribute(a,"");setTimeout(()=>document.documentElement.removeAttribute(a),4000)}}catch{}})();`;

export function rememberStaleTabOverlay(): void {
  try { sessionStorage.setItem(STALE_TAB_OVERLAY_STORAGE_KEY, String(Date.now())); } catch { /* Storage is optional. */ }
}
